import React from 'react';

const LoaderWrapper = (WrappedComponent) => {
	class Wrapper extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				isLoaded : false
			}

			this.child = React.createRef();
		}

		loaded = () => {
			this.setState({
				isLoaded: true
			})
		}

		loading = () => {
			this.setState({
				isLoaded: false
			})
		}

		render() {
			return (
				<WrappedComponent
					loaded={this.loaded}
					loading={this.loading}
					isLoaded={this.state.isLoaded}
					ref={this.child} {...this.props} />
			);
		}
	}
		
	return Wrapper; 
}

export default LoaderWrapper;